import React from 'react';
import { Grid, Typography, Box, FormControl, FormControlLabel, Radio, RadioGroup, Checkbox, TextField, Divider } from '@mui/material';

const PositionSection = ({ formData, handleChange }) => {
  return (
    <Box sx={{ mt: 3 }}>
      <Typography variant="h6" sx={{ color: '#008080', mb: 2, fontWeight: 'bold' }}>
        Step 3: Transfer & Positioning
      </Typography>
      
      <Grid container spacing={4}>
        <Grid item xs={12} sm={4}>
           <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 1 }}>Mode of Transfer to OT</Typography>
           <FormControl component="fieldset">
            <RadioGroup row name="mode_of_transfer_to_ot" onChange={handleChange} value={formData.mode_of_transfer_to_ot || ''}>
              {["Bed", "Stretcher", "Wheelchair"].map((pos) => (
                <FormControlLabel key={pos} value={pos} control={<Radio size="small" />} label={pos} />
              ))}
            </RadioGroup>
          </FormControl>
        </Grid>

        <Grid item xs={12} sm={4}>
           <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 1 }}>Anesthesia Type</Typography>
           <FormControl component="fieldset">
            <RadioGroup row name="anesthesia_type" onChange={handleChange} value={formData.anesthesia_type || ''}>
              {["Epidural", "Spinal", "Local", "Regional", "GA"].map((type) => (
                <FormControlLabel key={type} value={type} control={<Radio size="small" />} label={type} />
              ))}
            </RadioGroup>
          </FormControl>
        </Grid>

        <Grid item xs={12} sm={4}>
           <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 1 }}>Position</Typography>
           <FormControl component="fieldset">
            <RadioGroup row name="position" onChange={handleChange} value={formData.position || ''}>
              {["Supine", "Prone", "Lithotomy", "Right Lateral", "Left Lateral", "Other"].map((pos) => (
                <FormControlLabel key={pos} value={pos} control={<Radio size="small" />} label={pos} />
              ))}
            </RadioGroup>
          </FormControl>
        </Grid>
      </Grid>

      <Divider sx={{ my: 3 }} />

      <Typography variant="subtitle1" sx={{ color: '#008080', fontWeight: 'bold', mb: 2 }}>
        Pressure Protection Pads
      </Typography>
      <Grid container>
        {Object.keys(formData.pressure_protection_pad).map((test) => (
          <Grid item xs={6} sm={4} lg={3} key={test}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={formData.pressure_protection_pad[test] || false}
                  onChange={handleChange}
                  name={`pressure_protection_pad.${test}`}
                  size="small"
                />
              }
              label={test.replace(/_/g, ' ').replace(/^\w/, c => c.toUpperCase())}
            />
          </Grid>
        ))}
      </Grid>
      <TextField
        fullWidth
        name="pressure_protection_pad_other"
        label="Add Other Pads"
        variant="outlined"
        margin="normal"
        value={formData.pressure_protection_pad_other || ''}
        onChange={handleChange}
        size="small"
      />
    </Box>
  );
};

export default PositionSection;
